// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.button[data-v-7c45cbd5]{\r\n\twidth:100%;\r\n\ttext-transform: uppercase;\r\n\tfont-weight: bold;\r\n\tline-height: 25px;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
